module.exports = __webpack_public_path__ + "media/images/labs-feature-badge-51c9cc7218956f7ad0345be570d4d692.svg";